"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormHelpMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _spacingMixin = require("../spacingMixin");
var _typographyMixin = require("../typographyMixin");
/** @class FormHelpMixin */
/** @method */
var FormHelpMixin = function FormHelpMixin(props) {
  var error = props.error;
  return (0, _styledToken.default)({
    fontColor: error ? 'FormHelp.error.fontColor' : 'FormHelp.fontColor',
    fontType: 'FormHelp.fontType'
  }, function (_ref) {
    var fontColor = _ref.fontColor,
      fontType = _ref.fontType;
    return (0, _styledComponents.css)(["", " color:", ";margin:0;", ""], (0, _typographyMixin.typographyMixin)(Object.assign({
      fontType: fontType
    }, props)), fontColor, (0, _spacingMixin.spacingMixin)(props));
  })(props);
};
exports.FormHelpMixin = FormHelpMixin;